import { httpGet } from "utils/httpRequest"

const getTierPrograms = async () => {
  const resp = await httpGet("client/tier-program", {
    client_type: 2,
    client_version: "1.0.0"
  })
  return resp.data
}

export { getTierPrograms }
